<template>
	<div>
		<div class="row">
			<div class="col-md-8">
				Products:
				<br />
				<multiselect
					v-model="productIds"
					:options="searchedProducts"
					multiple
					:close-on-select="false"
					track-by="id"
					label="name"
					group-values="options"
					group-label="group_name"
					:internal-search="false"
					@search-change="doSearch"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>
				<small>Save deal to populate products.</small>
			</div>
			<div class="col-md-4">
				<div class="row">
					<div class="col-md-12">
						<label for="">Refresh Products?</label>
						<br />
						<select class="delay input-small form-control" v-model="rule.settings.end_type">
							<option value="delay">Delays</option>
							<option value="dates">Dates</option>
						</select>
					</div>
					<div v-if="rule.settings.end_type == 'delay'">
						<div class="d-flex mt-3">
							<div class="col-md-5">
								<select class="delay input-small form-control" v-model="rule.settings.delay">
									<option v-for="delay in 365" :value="delay" :key="delay">{{ delay }}</option>
								</select>
							</div>
							<div class="col-md-10">
								<select class="delayType input-small form-control" v-model="rule.settings.delay_type">
									<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
								</select>
							</div>
						</div>
						<div class="row col-md-10">
							<div class="col-md-12 mt-2">
								After:
								<br />
								<select class="delayType input-small form-control" v-model="rule.settings.delay_after">
									<option v-for="after in afters" :value="after" :key="after">{{ after }}</option>
								</select>
							</div>
						</div>
						<div class="col-md-10">
							<label for="rule_max_redemptions">Max redemptions:</label> <input id="rule_max_redemptions" class="form-control" v-model="rule.settings.max_redemptions"></input>
							<span class="font-size-sm text-muted">Leave blank for unlimited.</span>
						</div>
					</div>
					<div class="col-md-12 mt-2 mb-2 pt-2 pb-2" :class="rule.settings.end_dates && rule.settings.end_dates.length > 0 ? 'bg-white' : '' " v-if="rule.settings.end_type == 'dates'">
						<div class="d-flex">
							<date-picker
								placeholder="Select a Date"
								id="deal-rule-date-picker"
								:config="datePickerConfig" 
								single-date-picker="false" 
								@dp-hide="rule.settings.prep_date = $event.target.value" 
								:value="rule.settings.prep_date"
								:style="dataError ? 'box-shadow: 0px 0px 3px red;' : '' "
							>
							</date-picker>
							<button type="button" class="btn btn-success btn-sm ml-2" @click="addDealDate">
								<i class="fa fa-plus"></i>
							</button>
						</div>
						<div class="d-flex mt-3 mb-3 justify-content-between" v-for="(date, index) in rule.settings.end_dates" :key="index">
							<div class="d-flex align-items-center">{{ Bandwango.dateToLocal(date) }}</div>
							<button type="button" class="btn btn-sm btn-danger ml-2" @click="$emit('remove-end-date', index)"><i class="fa fa-times"></i></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		rule: {
			type: Object,
			required: true,
		},
		products: {
			type: Array,
			required: true,
		},
		deal: {
			type: Object,
		}
	},
	data() {
		return {
			types: ["years", "months", "days", "hours", "minutes"],
			afters: ["redemption", "purchase"],
			searchedProducts: [],
			dataError: false,
			datePickerConfig: {
				minDate: new Date(),
				sideBySide: true,
			}
		};
	},
	computed: {
		dealProductIds() {
			return this.deal.products.map(p => p.product_id);
		},
		filteredProducts() {
			let prods = [];
			this.products.forEach((group) => {
				let filtered = group.options.filter((option) => this.dealProductIds.indexOf(option.id) > -1 );
				if (filtered.length > 0) prods.push({ group_name: group.group_name, options: filtered });
			});
			return prods;
		},
		productIds: {
			get() {
				let values = [];
				this.products.forEach((group) => {
					let filtered = group.options.filter((option) => {
						return (
							this.rule.settings.product_ids.map(Number).indexOf(option.id) > -1
						);
					});
					if (filtered.length > 0) values = values.concat(filtered);
				});
				return values;
			},
			set(newVal) {
				this.rule.settings.product_ids = newVal.map((v) => v.id);
			},
		},
	},
	methods: {
		addDealDate() {
			if(this.rule.settings.prep_date) {
				this.dataError = false
				this.$emit('set-end-date', this.rule.settings.prep_date); 
				this.rule.settings.prep_date = ''
			} else {
				this.dataError = true
			}
		},
		doSearch(query) {
			if (query === "") this.searchedProducts = this.filteredProducts;
			else {
				const options = {
					ignoreFieldNorm: true,
					ignoreLocation: true,
					threshold: 0.0,
					keys: ["group_name", "options.name"],
				};
				const fuse = new Fuse(this.filteredProducts, options);
				this.searchedProducts = fuse.search(query).map((res) => res.item);
			}
		},
	},
	created() {
		this.searchedProducts = this.filteredProducts;
	},
	mounted() {
		let vm = this;

		Vue.nextTick(() => {
			// setup defaults
			vm.rule.settings = _.extend(
				{ delay: 1, delay_type: "years", delay_after: "redemption", end_type: 'delay' },
				vm.rule.settings
			);
			vm.$forceUpdate();
		});
	},
};
</script>

<style scoped>
.deal-date-item {
	display: flex;
	border-bottom: 1px solid lightgray;
	padding-bottom: 10px;
}
</style>